import { lazy, Suspense } from "react";

import { LoadingIndicatorFullPage } from "../../../cc-ui/components";

const RoomAttestationPage = lazy(() =>
  import("./RoomAttestationPage").then((module) => ({ default: module.RoomAttestationPage })),
);

export function RoomAttestationAsync() {
  return (
    <Suspense fallback={<LoadingIndicatorFullPage open />}>
      <RoomAttestationPage />
    </Suspense>
  );
}
